import {
  Alert,
  Box,
  Grid,
  IconButton,
  Paper,
  Skeleton,
  Typography,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  formatCurrency,
  formatDate,
  formatList,
  formatQueryError,
} from 'renderer/shared/formatters/formatters';
import { useListProductsQuery } from 'renderer/features/products-page/services/products.endpoints';
import { capitalize } from 'lodash';
// import { Discount } from '../schemas/discounts.schemas';
import { useListResellerCodesQuery } from '../services/resellerCodes.endpoints';

interface TableCellProps {
  name: string;
  value: string;
  size?: number;
}

const Cell = ({ name, value, size }: TableCellProps) => {
  return (
    <Grid container spacing={1} item direction="column" xs={size ?? 3}>
      <Grid item>
        <Typography variant="subtitle1" fontWeight="bold">
          {name}
        </Typography>
      </Grid>
      <Grid item>
        <Typography>{value}</Typography>
      </Grid>
    </Grid>
  );
};

interface ResellerCodesListProps {
  // handleEditClick: (discount: Discount) => void;
  // handleDeleteClick: (discount: Discount) => void;
  handleEditClick: (resellerCode: any) => void;
  handleDeleteClick: (resellerCode: any) => void;
}

const ResellerCodesList = ({
  // discounts,
  // error,
  // isLoading,
  handleEditClick,
  handleDeleteClick,
}: ResellerCodesListProps) => {
  const {
    data: resellerCodes,
    isLoading: resellerCodesLoading,
    error,
  } = useListResellerCodesQuery({});
  const { data: products } = useListProductsQuery({ includeHidden: true });
  const isLoading = resellerCodesLoading || !products;

  // const formatAmount = (discount: Discount) =>
  //   discount.amountUnits === 'dollars'
  //     ? formatCurrency(discount.amount)
  //     : `${discount.amount}%`;

  return (
    <Grid container item spacing={2} xs={12} sm={12}>
      {isLoading && (
        <>
          <Grid item>
            <Skeleton height={100} variant="rounded" width={500} />
          </Grid>
          <Grid item>
            <Skeleton height={100} variant="rounded" width={500} />
          </Grid>
        </>
      )}
      {resellerCodes &&
        products &&
        resellerCodes.map((resellerCode: any) => (
          <Grid item xs={12} sm={12} key={resellerCode.code}>
            <Paper
              elevation={1}
              sx={{
                padding: 2,
                my: 1,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Grid container spacing={2} direction="row">
                {/* <Grid item xs={12}>
                  <Typography variant="h5">
                    <strong>{formatAmount(discount)}</strong> Off{' '}
                    <strong>{capitalize(discount.duration)}</strong> With Code{' '}
                    <strong>{discount.code}</strong>
                  </Typography>
                </Grid> */}
                <Cell name="Reseller" value={resellerCode.resellerName} />
                <Cell name="Code" value={resellerCode.code} />
                <Cell name="Product" value={resellerCode.productId.name} />

                <Cell
                  name="Created"
                  value={`${formatDate(new Date(resellerCode.createdAt))} `}
                />
                <Cell
                  name="Redeemed"
                  value={`${
                    resellerCode.dateRedeemed
                      ? formatDate(new Date(resellerCode.dateRedeemed))
                      : ''
                  } `}
                />
                {/* <Cell
                  name="Minimum"
                  value={
                    discount.minimum === undefined
                      ? 'None'
                      : `${discount.minimum} ${discount.minimumUnits}`
                  }
                />
                <Cell
                  name="Active Between"
                  value={`${formatDate(
                    new Date(discount.start),
                  )} - ${formatDate(new Date(discount.end))}`}
                />
                <Cell
                  name="Products"
                  value={
                    discount.productIds.length
                      ? formatList(
                          discount.productIds.map((id) => {
                            const product = products.find((p) => p._id === id);
                            return product ? product.name : '';
                          }),
                        )
                      : 'All Products'
                  }
                /> */}
              </Grid>
              <Box>
                {/* <IconButton onClick={() => handleEditClick(resellerCode)}>
                  <EditIcon />
                </IconButton> */}
                <IconButton onClick={() => handleDeleteClick(resellerCode)}>
                  <DeleteIcon />
                </IconButton>
              </Box>
            </Paper>
          </Grid>
        ))}
      {error && (
        <Grid item xs={12}>
          <Alert severity="error">
            Error retrieving reseller codes: {formatQueryError(error)}
          </Alert>
        </Grid>
      )}
    </Grid>
  );
};

export default ResellerCodesList;
